module.exports = __webpack_public_path__ + "static/img/ezwel-renewal-img-02-03@m.041153c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezwel-renewal/optimized/ezwel-renewal-img-02-03@m.jpg
// module id = dbPQ
// module chunks = 0